// (function ($) {
//     $(document).ready(function () {
  
//       $('#custom-engraving input#gift-wrapping').on('change', function () {
//         $('#custom-engraving .gift-wrapping-text, #custom-engraving .gift-wrapping-style').toggleClass('hide');
  
//         if (this.checked) {
//           var style = $('#custom-engraving .gift-wrapping-option.selected .option-label').text().trim();
//           $(this).after('<input type="hidden" name="properties[Gift Wrapping Style]" value="' + style + '"/>');
//           $('#custom-engraving .gift-wrapping-text input').attr('name', 'properties[Gift Wrapping Note]');
//           $('#custom-engraving .gift-wrapping-text input').attr('required', true);
//         } else {
//           $(document).find('form.product-form input[name="properties[Gift Wrapping Style]"]').remove();
//           $('#custom-engraving .gift-wrapping-text input').removeAttr('name');
//           $('#custom-engraving .gift-wrapping-text input').removeAttr('required');
//           $('#custom-engraving .gift-wrapping-text input').val('');
//         }
//       });
  
//       $('#custom-engraving input#custom-engraving-checkbox').on('change', function () {
//         $('#custom-engraving .engraving-style, #custom-engraving .engraving-text').toggleClass('hide');
  
//         if (this.checked) {
//           var style = $('#custom-engraving .engraving-option.selected .option-label').text().trim();
//           console.log("style1",style)
//           $(this).after('<input type="hidden" name="properties[Engraving Style]" value="' + style + '"/>');
//           $(this).after('<input type="hidden" name="properties[Custom Engraving]" value="Yes"/>');
//           $('#custom-engraving .engraving-input').attr('name', 'properties[Engraving Note]');
//           $('#custom-engraving .engraving-input').attr('required', true);
//           $('#custom-engraving #engraving-variant-id').attr('name', 'properties[Engraving Variant ID]')
//         } else {
//           $(document).find('form.product-form input[name="properties[Custom Engraving]"]').remove();
//           $(document).find('form.product-form input[name="properties[Engraving Style]"]').remove();
//           $('#custom-engraving .engraving-input').removeAttr('name');
//           $('#custom-engraving .engraving-input').removeAttr('required');
//           $('#custom-engraving .engraving-input').val('');
//           $('#custom-engraving #engraving-variant-id').removeAttr('name');
//         }
//       });
  
//       $('#custom-engraving .engraving-option').magnificPopup({
//         delegate: 'img', // child items selector, by clicking on it popup will open
//         type: 'image',
//         gallery: {
//           enabled: true
//         }
//       });

//       $('#custom-engraving .gift-wrapping-option').magnificPopup({
//         delegate: 'img', // child items selector, by clicking on it popup will open
//         type: 'image',
//         gallery: {
//           enabled: true
//         }
//       });
  
//       $('#custom-engraving .engraving-option .option-label').on('click', function () {
//         var option = $(this).closest('.engraving-option');
//         var text_limit = option.attr('data-text-limit');
//         $('#custom-engraving .engraving-option').removeClass('selected');
//         option.addClass('selected');
  
//         $('#custom-engraving .engraving-input').val('');
//         $('#custom-engraving .engraving-input').attr('maxlength', text_limit);
  
//         $('#custom-engraving .engraving-input-limit').text(text_limit);
  
//         var style = option.find('.option-label').text().trim();
//         $(document).find('input[name="properties[Engraving Style]"]').val(style);
//       });

//       $('#custom-engraving .gift-wrapping-option .option-label').on('click', function () {
//         console.log("hihi")
//         var option = $(this).closest('.gift-wrapping-option');
//         var text_limit = option.attr('data-text-limit');
//         $('#custom-engraving .gift-wrapping-option').removeClass('selected');
//         option.addClass('selected');
  
//         $('#custom-engraving .gift-wrapping-input').val('');
  
//         var style = option.find('.option-label').text().trim();
//         $(document).find('input[name="properties[Gift Wrapping Style]"]').val(style);
//       });
  
//     });
//   })(jQuery);


document.addEventListener('DOMContentLoaded', function () {
  var giftWrappingCheckbox = document.getElementById('gift-wrapping');
  var giftWrappingText = document.querySelector('#custom-engraving .gift-wrapping-text');
  var engravingCheckbox = document.getElementById('custom-engraving-checkbox');
  var engravingText = document.querySelector('#custom-engraving .engraving-text');
  var engravingStyle = document.querySelector('#custom-engraving .engraving-style');

  if(giftWrappingCheckbox){
    giftWrappingCheckbox.addEventListener('change', function () {
      toggleClass(giftWrappingText, 'hide');
      
      if (this.checked) {
        if(document.querySelector('#custom-engraving .gift-wrapping-option.selected .option-label')){
          var style = document.querySelector('#custom-engraving .gift-wrapping-option.selected .option-label').textContent.trim();
          this.insertAdjacentHTML('afterend', '<input type="hidden" name="properties[Gift Wrapping Style]" value="' + style + '"/>');
        }
        document.querySelector('#custom-engraving .gift-wrapping-text input').name = 'properties[Gift Wrapping Note]';
        document.querySelector('#custom-engraving .gift-wrapping-text input').required = true;
      } else {
        removeElement('form.product-form input[name="properties[Gift Wrapping Style]"]');
        document.querySelector('#custom-engraving .gift-wrapping-text input').name = '';
        document.querySelector('#custom-engraving .gift-wrapping-text input').required = false;
        document.querySelector('#custom-engraving .gift-wrapping-text input').value = '';
      }
    });
  }

  if(engravingCheckbox){
    engravingCheckbox.addEventListener('change', function () {
      toggleClass(engravingText, 'hide');
      toggleClass(engravingStyle, 'hide');
      
      if (this.checked) {
        var style = document.querySelector('#custom-engraving .engraving-option.selected .option-label').textContent.trim();
        console.log("style1", style);
        this.insertAdjacentHTML('afterend', '<input type="hidden" name="properties[Engraving Style]" value="' + style + '"/>');
        this.insertAdjacentHTML('afterend', '<input type="hidden" name="properties[Custom Engraving]" value="Yes"/>');
        document.querySelector('#custom-engraving .engraving-input').name = 'properties[Engraving Note]';
        document.querySelector('#custom-engraving .engraving-input').required = true;
        document.querySelector('#engraving-variant-id').name = 'properties[Engraving Variant ID]';
      } else {
        removeElement('form.product-form input[name="properties[Custom Engraving]"]');
        removeElement('form.product-form input[name="properties[Engraving Style]"]');
        document.querySelector('#custom-engraving .engraving-input').name = '';
        document.querySelector('#custom-engraving .engraving-input').required = false;
        document.querySelector('#custom-engraving .engraving-input').value = '';
        document.querySelector('#engraving-variant-id').name = '';
      }
    });
  }

  document.querySelectorAll('#custom-engraving .engraving-option .option-label').forEach(function (img) {
    img.addEventListener('click', function () {
      var option = this.closest('.engraving-option');
      var textLimit = option.dataset.textLimit;
      document.querySelectorAll('#custom-engraving .engraving-option').forEach(function (opt) {
        opt.classList.remove('selected');
      });
      option.classList.add('selected');
      document.querySelector('#custom-engraving .engraving-input').value = '';
      document.querySelector('#custom-engraving .engraving-input').maxLength = textLimit;
      // document.querySelector('#custom-engraving .engraving-input-limit').textContent = textLimit;
      var style = option.querySelector('.option-label').textContent.trim();
      document.querySelector('input[name="properties[Engraving Style]"]').value = style;
    });
  });

  document.querySelectorAll('#custom-engraving .gift-wrapping-option .option-label').forEach(function (img) {
    img.addEventListener('click', function () {
      console.log("hihi");
      var option = this.closest('.gift-wrapping-option');
      var textLimit = option.dataset.textLimit;
      document.querySelectorAll('#custom-engraving .gift-wrapping-option').forEach(function (opt) {
        opt.classList.remove('selected');
      });
      option.classList.add('selected');
      document.querySelector('#custom-engraving .gift-wrapping-input').value = '';
      var style = option.querySelector('.option-label').textContent.trim();
      document.querySelector('input[name="properties[Gift Wrapping Style]"]').value = style;
    });
  });

  function toggleClass(element, className) {
    if (element.classList.contains(className)) {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  }

  function removeElement(selector) {
    var element = document.querySelector(selector);
    if (element) {
      element.remove();
    }
  }
   // Lấy phần tử của gallery
  //  var galleryElement = document.getElementById('product-gallery');

  //  // Lấy các phần tử con của gallery
  //  var galleryItems = galleryElement.querySelectorAll('.engraving-option');
 
  //  // Khởi tạo mảng chứa các item của thư viện
  //  var items = [];
 
  //  // Lặp qua các phần tử và thêm chúng vào mảng items
  //  galleryItems.forEach(function (element) {
  //    var link = element.querySelector('img');
 
  //    var item = {
  //      src: link.getAttribute('data-mfp-src'), // Ảnh lớn
  //      w: link.getAttribute('data-width'),    // Chiều rộng ảnh
  //      h: link.getAttribute('data-height'),   // Chiều cao ảnh
  //    };
 
  //    items.push(item);
 
  //    // Gán sự kiện click cho từng phần tử để mở thư viện hình ảnh
  //    element.addEventListener('click', function (e) {
  //      e.preventDefault();
 
  //      var pswpElement = document.querySelectorAll('.pswp')[0];
 
  //      // Khởi tạo thư viện
  //      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
  //        index: items.indexOf(item), // Vị trí của ảnh được chọn
  //        bgOpacity: 0.8,
  //        captionEl: false,
  //        tapToClose: true,
  //        shareEl: false,
  //        fullscreenEl: false,
  //      });
 
  //      // Mở thư viện
  //      gallery.init();
  //    });
  //  });
});

// (function ($) {
//   $(document).ready(function () {
//     $('#custom-engraving .engraving-option').magnificPopup({
//       delegate: 'img', // child items selector, by clicking on it popup will open
//       type: 'image',
//       gallery: {
//         enabled: true
//       }
//     });

//     $('#custom-engraving .gift-wrapping-option').magnificPopup({
//       delegate: 'img', // child items selector, by clicking on it popup will open
//       type: 'image',
//       gallery: {
//         enabled: true
//       }
//     });
// })(jQuery);